import dateFormat from 'dateformat';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JobCard.module.scss';
import { CardSummary } from './CardSummary';

function JobCard({ data, onClick, isFocused, setFocus }) {
  const { JobTitle, JobDescription, IsApplied, Location, PublishedDate, JobType, Id } = data;
  const { t } = useTranslation();
  return (
    <div data-testid="board" className={`${styles.JobCard} ${isFocused ? styles.JobCard_setJob : ''}`}>
      <div className={`${styles.cardInfo}`}>
        <div className={`${styles.cardInfo__primary}`}>
          <div className={`${styles.cardInfo__primary__left}`}>{JobTitle}</div>
          <div className={`${styles.cardInfo__primary__right}`}>
            {IsApplied && <div className={styles.appliedTag}>{t('dashboard.jobs.applied')}</div>}
            <div className={styles.date}>{dateFormat(PublishedDate, 'dd mmm yyyy')}</div>
            {/* {saved ? <BookmarkIcon onClick={()=>setSaved(false)} className={styles.savedIcon} fontSize="small" />
              : <BookmarkBorderIcon onClick={clickToSave} className={styles.unsaveIcon} fontSize="small" />} */}
          </div>
        </div>
        <div className={`${styles.cardInfo__secondary}`}>
          <div className={styles.location}>
            <LocationOnOutlinedIcon className={styles.location__icon} />
            <span className={styles.location__place}>{Location}</span>
          </div>
          <div className={styles.job}>
            <ArticleOutlinedIcon className={styles.job__icon} />
            <span className={styles.job__type}>{JobType}</span>
          </div>
        </div>
      </div>
      <CardSummary
        jobId={data?.Id}
        text={JobDescription}
        length={120}
        onClick={() => {
          setFocus();
          onClick();
        }}
      />
    </div>
  );
}

export default JobCard;
